import AxiosClient from '../../../../services/axios.services';

class SurveyTemplateQuestionOptionsServices {
  getSurveyTemplateQuestionOptions = (params) =>
    AxiosClient.get("/api/app/SurveyQuestionOption/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getSurveyTemplateQuestionOptionById = (id) =>
    AxiosClient.get(`/api/app/SurveyQuestionOption/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveSurveyTemplateQuestionOption = (data) =>
    AxiosClient.post("/api/app/SurveyQuestionOption/", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  editSurveyTemplateQuestionOption = (id, data) =>
    AxiosClient.put(`/api/app/SurveyQuestionOption/${id}/`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  updateSurveyTemplateQuestionOptionSecuence = (data) =>
    AxiosClient.post("/api/app/SurveyQuestionOption/", data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteSurveyTemplateQuestionOption = (id) =>
    AxiosClient.delete(`/api/app/SurveyQuestionOption/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new SurveyTemplateQuestionOptionsServices();